// -- Endpoints --

// Pass test
export const TEST_PASSING = 'api/online-test/:id/pass-test';
export const TEST_SET_ANSWER = 'api/online-test/:id/answer';
export const TEST_COMPLETE = 'api/online-test/:id/complete';

export default TEST_PASSING;
